'use client';
import React, { Fragment, useEffect, useState } from 'react'
import PageHeading from "Layout/AppMain/PageHeading";
import TransitionOnLoad from "Components/TransitionOnLoad";
import DocumentenGoedkeuren from './DocumentenGoedkeuren';
import { CardFooter } from "reactstrap";
import PDFViewer from './PDFViewer';
import Loader from "react-loaders";
import { Card, CardBody } from "reactstrap";
import RejectOrDeleteModal from './RejectOrDeleteModal';
import SupportService from 'Api/Support';
import { toast } from 'react-toastify';
import { useApiMutation } from 'services/useApiMutation';

const DocsGoedkeuren = () => {
    const [list, setList] = useState({});
    const [adminLists, setAdminLists] = useState([]);
    const [arrFilters, setArrFilters] = useState({});
    const [arrTypes, setArrTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [openRejectORDeleteModal, setOpenRejectOrDeleteModal] = useState({
        value: '',
        status: false
    });
    const [filterData, setFilterData] = useState({
        status: 'open',
        admin: '-1',
        doc: '-1',
        page: 0,
    });

    const { trigger: fetchDocumentTrigger } = useApiMutation();
    const { trigger: updateStatusTrigger } = useApiMutation();

    useEffect(() => {

        fetchDocument();
    }, [filterData])

    const filterHandler = (key, value) => {
        setFilterData(prev => {
   
            if (key === 'status' || key === 'doc' || key === 'admin') {
                return {
                    ...prev,
                    [key]: value,
                    page: 0,
                    prev: undefined,
                    next: undefined,
                };
            }

            // Pagination
            const currentPage = prev.page || 0;
            const newPage =
                key === 'next'
                    ? currentPage + 1
                    : Math.max(0, currentPage - 1);

            return {
                ...prev,
                page: newPage,
                ...(key === 'next'
                    ? { next: newPage, prev: undefined }
                    : { prev: newPage, next: undefined }),
            };
        });
    };


    const fetchDocument = () => {
        const { status, admin, doc, prev, next } = filterData;
        let query = `status=${status}`;
        if (doc) query += `&doc=${doc}`;
        if (admin) query += `&admin=${admin}`;
        if (next) query += `&next=${next}`;
        if (prev) query += `&prev=${prev}`;

        fetchDocumentTrigger(() =>
            SupportService.fetchDocument(query)
        ).then((response) => {
         
            if (response?.status) {
                response?.data.lists ? setList(response?.data.lists) : setList({});
                response?.data.adminLists ? setAdminLists(response?.data.adminLists) : setAdminLists([]);
                response?.data.arrFilters ? setArrFilters(response?.data.arrFilters) : setArrFilters({});
                response?.data.arrTypes ? setArrTypes(response?.data.arrTypes) : setArrTypes([]);
                setIsLoading(false);
            }
        }).catch((error) => {
            console.error('Error fetching document:', error);
            setIsLoading(false);
        });
    }

    const handleUpdateStatus = (status, value, setSubmitting = null) => {
        const data = {
            adminDocId: list?.id,
            status: status,
            ...(value && { reason: value }),
        };

        updateStatusTrigger(() =>
            SupportService.UpdateStatus(data)
        ).then((response) => {
            if (response?.status) {
                setOpenRejectOrDeleteModal(false);
                toast.success(response?.message);
            } else {
                toast.error(response?.message);
            }
        }).catch(() => {
            toast.error("Serverfout. Probeer het later opnieuw.");
        }).finally(() => {
            setSubmitting && setSubmitting(false);
        })
    }

    return (
        <div className='support-docs'>
            <PageHeading />
            <TransitionOnLoad>
                <div className='row card-heading-body mb-5'>
                    <div className='col-xl-4'>
                        {
                            isLoading || (list && typeof list === 'object' && !Array.isArray(list) && Object.keys(list).length === 0) ? <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                </CardBody>
                            </Card> : <DocumentenGoedkeuren data={list} />
                        }
                    </div>
                    <div className='col-xl-8 mt-xl-0 mt-4 pdf-viewer'>
                        {
                            Object.keys(list).length === 0 || isLoading ? <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    <Loader type="ball-grid-pulse" className={'mt-3 d-flex mx-auto justify-content-center'} />
                                </CardBody>
                            </Card> : <PDFViewer pdfUrl={list?.pdf} />
                        }
                    </div>
                </div>
            </TransitionOnLoad>

            <div className="chat-layout-footer verzoken-footer-height">
                <CardFooter className="chat-layout-footer__inner gebruikers-footer">
                    <div className="d-flex justify-content-between">
                        <div className='d-flex gap-3'>
                            <select
                                className="form-select"
                                value={filterData.status}
                                onChange={(e) => filterHandler('status', e.target.value)}
                            >
                                <option value="open">Openstaand</option>
                                <option value="rejected">Afgekeurd</option>
                                <option value="approved">Goedgekeurd</option>
                                <option value="approved_possession">Goedgekeurd ++</option>
                            </select>
                            <select
                                className="form-select"
                                value={filterData.doc}
                                onChange={(e) => filterHandler('doc', e.target.value)}
                            >
                                <option value="-1">Alle documenten</option>

                                {arrTypes?.map(item => (
                                    <option
                                        key={item.iDocTypeId}
                                        value={item.iDocTypeId}
                                    >
                                        {item.vLabel}
                                    </option>
                                ))}
                            </select>
                            <select
                                className="form-select select"
                                value={filterData.admin}
                                onChange={(e) => filterHandler('admin', e.target.value)}
                            >
                                <option value="-1">Alle vervangers</option>

                                {adminLists?.map(item => (
                                    <option
                                        key={item.iAdminId}
                                        value={item.iAdminId}
                                    >
                                        {item.vAdminName}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-wrap justify-content-end gap-3 text-end">
                            <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={() => filterHandler('prev')} disabled={filterData.page === 0}
                            >
                                Vorige
                            </button>
                            <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={() => filterHandler('next')}>
                                Volgende
                            </button>
                            <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={() => setOpenRejectOrDeleteModal({ status: true, value: 'delete' })}>
                                Verwijderen
                            </button>
                            <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={() => setOpenRejectOrDeleteModal({ status: true, value: 'reject' })} >
                                Afkeuren
                            </button>
                            <button className="btn btn-outline-primary btn-color-style d-flex justify-content-center align-items-center gap-2" onClick={() => handleUpdateStatus('approved')} >
                                Goedkeuren
                            </button>
                        </div>
                    </div>
                </CardFooter>

                {openRejectORDeleteModal?.status && <RejectOrDeleteModal handleUpdateStatus={handleUpdateStatus} openRejectORDeleteModal={openRejectORDeleteModal} setOpenRejectOrDeleteModal={setOpenRejectOrDeleteModal} />}
            </div>
        </div>
    )
}

export default DocsGoedkeuren;
